import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ClientsService } from '@core/services';
import { UserSessionService } from '@core/services/user-session';
import { UserRole } from 'jplus-design-system-angular';
import { filter, map, take } from 'rxjs';

export const hasMainRoleGuard: CanActivateFn = () => {
  const userSessionService = inject(UserSessionService);
  const clientsService = inject(ClientsService);
  const router = inject(Router);

  return userSessionService.user$.pipe(
    filter(user => !!user),
    take(1),
    map(user => {
      if (user.role === UserRole.Jellyfish) {
        return true;
      }

      if (Object.keys(clientsService.currentClient.value).length) {
        return router.createUrlTree([clientsService.currentClient.value.slug, 'projects']);
      }

      return router.createUrlTree(['redirect']);
    })
  );
};
